import React from 'react';

import { WarningOutlined } from '@ant-design/icons';
import { Flex, Tooltip } from 'antd';
import { useTranslation } from 'react-i18next';

import { NSKeys } from '@app/i18n';
import { ReserveStateSchema, WarehouseReserveStatus } from '@app/models/orders';

import { ListItem } from '@components/ListItem';
import { StatusTag } from '@components/StatusTag';

interface IProps {
  reserveState: ReserveStateSchema;
}

const STATUS_COLORS: Record<Uppercase<WarehouseReserveStatus>, string> = {
  IN_PROGRESS: '#89CFF0',
  RESERVED: '#52c41a',
  FAILED: '#ff4d4f',
  CANCELLED: '#8c8c8c',
};

export const ReserveStatusTag: React.FC<IProps> = ({ reserveState }) => {
  const orderT = useTranslation(NSKeys.order);

  const statusColorKey = reserveState.status.toUpperCase() as Uppercase<WarehouseReserveStatus>;
  const label = orderT.t(`blockReservation.status.${reserveState.status}`);

  const color = STATUS_COLORS[statusColorKey] || STATUS_COLORS.CANCELLED;

  if (reserveState.status !== 'failed' || !reserveState.error) {
    return (
      <ListItem title={orderT.t('blockReservation.label')} description={null}>
        <StatusTag color={color} name={label} />
      </ListItem>
    );
  }

  return (
    <ListItem title={orderT.t('blockReservation.label')} description={null}>
      <Flex>
        <StatusTag color={color} name={label} />
        <Tooltip placement="top" title={reserveState.error}>
          <WarningOutlined style={{ fontSize: 20, color: STATUS_COLORS.FAILED }} />
        </Tooltip>
      </Flex>
    </ListItem>
  );
};
